import React from "react";
import { Link } from "react-router-dom";
import { SiFlutter, SiFirebase, SiNodedotjs, SiMongodb, SiReact, SiFigma } from "react-icons/si";
import { FaGithub, FaGlobe } from "react-icons/fa";
import "./Projects.css";
import projectList from "../data/projects";

const techIconMap = {
  flutter: <SiFlutter />,
  firebase: <SiFirebase />,
  node: <SiNodedotjs />,
  mongo: <SiMongodb />,
  react: <SiReact />,
  figma: <SiFigma />,
};

export default function Projects() {
  return (
    <section id="projects" className="projects-minimal">
      <div className="projects-header">
        <h2>Projects</h2>
      
      </div>

      <div className="projects-grid">
        {projectList.map((proj) => {
          const secondary = proj.live || proj.repo;
          const secondaryLabel = proj.live ? "Live Demo" : "GitHub";
          const secondaryIcon = proj.live ? <FaGlobe /> : <FaGithub />;

          return (
            <article key={proj.slug} className="project-card">
              <div className="project-media">
                <img src={proj.image} alt={`${proj.title} preview`} />
                <div className="media-glow" />
              </div>

              <div className="project-meta">
                <div>
                  <h3>{proj.title}</h3>
                  <p className="tagline">{proj.tagline}</p>
                </div>

                <div className="project-actions">
                  <Link className="btn primary" to={`/projects/${proj.slug}`}>
                    View 
                  </Link>
                  {secondary ? (
                    <a className="btn ghost" href={secondary} target="_blank" rel="noreferrer">
                      {secondaryIcon}
                      {secondaryLabel}
                    </a>
                  ) : (
                    <span className="btn ghost disabled" aria-disabled="true">
                      {secondaryIcon}
                      {secondaryLabel}
                    </span>
                  )}
                </div>
              </div>

              <div className="tech-corner" aria-hidden>
                {proj.tech.slice(0, 4).map((key) => (
                  <span key={key} className="tech-icon">
                    {techIconMap[key]}
                  </span>
                ))}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
